import React from 'react';
import Header from '../../components/layout/Header';
import NotificationList from '../../components/notifications/NotificationList';

export default function BrandNotifications() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Header title="Notifications" subtitle="Decisions, updates and alerts from your manufacturers" />
      <div className="flex-1 overflow-y-auto p-6">
        <NotificationList basePath="/brand" />
      </div>
    </div>
  );
}
